"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKIllustration = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var GKIllustration_models_1 = require("./GKIllustration.models");
require("./GKIllustration.css");
/**
 * Wrapper component for illustrations provided by the assets package. Illustrations have a minimum size o
 * 96 pixels and a maximum of 512. Otherwise the illustration will fill its container.
 */
var GKIllustration = function (_a) {
    var name = _a.name, alt = _a.alt, src = _a.src, otherProps = __rest(_a, ["name", "alt", "src"]);
    var imgAlt;
    var imgSrc;
    if (name !== undefined) {
        imgAlt = GKIllustration_models_1.GKIllustrationMapping[name].alt;
        imgSrc = GKIllustration_models_1.GKIllustrationMapping[name].src;
    }
    else {
        imgAlt = alt;
        imgSrc = src;
    }
    return (React.createElement("img", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
        _gkComponentName: "gk-illustration",
        className: "gil",
    }), { src: imgSrc, alt: imgAlt })));
};
exports.GKIllustration = GKIllustration;
